import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine';
import {
    resetAllTeethToInitialPosition as _resetAllTeethToInitialPosition,
    hasAnyToothBeenModified as _hasAnyToothBeenModified,
    setPivotOnBarycenter,
    resetSelectedToothToInitialPosition,
    restoreSelectedToothToNextPosition,
    undoSelectedToothLastMovement
} from './ToothTransformHandler';

import {
    enableSelectionMode,
    disableSelectionMode,
    isSelectionModeEnabled,
    registerDoubleClickHandler
} from './ToothSelectionHandler';

import {
    saveModifications as _saveModifications,
    removeModification as _removeModification,
    refreshModifications,
    clearSessionMovementHistory,
    addToSessionMovementHistory,
    collectToothDataForSave,
    collectMalocAndSetupVersionsData,
    setSaveHandlerData
} from './ToothSaveHandler';

import { applyModification as _applyModification } from './ModificationApplier';
import { setupKeyboardShortcuts } from './KeyboardShortcuts';
import { computeToothMatrix, computeToothAxes } from '../Calculation/ToothAxesCalculator';

/* ──────────────────────────────────────────────
   MODULE STATE
   ────────────────────────────────────────────── */

let maxiMatrixHandler = [];
let mandiExtraHandler = [];
let globalTeethObjects = [];

const getContext = () => ({
    maxiMatrixHandler,
    mandiExtraHandler,
    globalTeethObjects
});

/* ──────────────────────────────────────────────
   INITIALIZATION
   ────────────────────────────────────────────── */

export const OnMeshClick = (canvas, renderer, controls, maxiExtraData, mandiExtraData) => {
    maxiMatrixHandler = maxiExtraData;
    mandiExtraHandler = mandiExtraData;
    setupKeyboardShortcuts();
    initializeTeethMatricesAndAxes(maxiExtraData, mandiExtraData);

    const { allObjects, allToothObjects } = getAllTeethObjects(maxiExtraData, mandiExtraData);
    storeTeethObjects(allToothObjects);

    const activeControls = controls || threeEngine.getControls();
    registerDoubleClickHandler(canvas, renderer, activeControls, allObjects, allToothObjects, maxiExtraData, mandiExtraData);
};

const initializeTeethMatricesAndAxes = (maxiExtraData, mandiExtraData) => {
    GetMallocMatrixAndAxesCalculator(maxiExtraData, mandiExtraData);
    GetMallocMatrixAndAxesCalculator(threeEngine.getMaxiExtraDataComparative(), threeEngine.getMandiExtraDataComparative());
};

const storeTeethObjects = (allToothObjects) => {
    globalTeethObjects = allToothObjects;
    threeEngine.setAllToothObjects(allToothObjects);
    setSaveHandlerData(maxiMatrixHandler, mandiExtraHandler, globalTeethObjects);
};

const getAllTeethObjects = (maxiExtraData, mandiExtraData) => {
    const mandiGroup = threeEngine.getMandiGroup();
    const maxiTeeth = Object.values(maxiExtraData);
    const mandiTeeth = Object.values(mandiExtraData);
    const allToothObjects = [...maxiTeeth, ...mandiTeeth];
    const allObjects = allToothObjects.map(tooth => tooth.refObj);
    return { allObjects, allToothObjects };
};

export const GetMallocMatrixAndAxesCalculator = (maxiExtraData, mandiExtraData) => {
    initializeTeethMatrices(maxiExtraData);
    initializeTeethMatrices(mandiExtraData);
};

const initializeTeethMatrices = (teethData) => {
    Object.values(teethData).forEach(toothData => {
        computeToothMatrix(toothData);
        computeToothAxes(toothData);
    });
};

/* ──────────────────────────────────────────────
   PUBLIC API WRAPPERS (preserve signatures)
   ────────────────────────────────────────────── */

export { enableSelectionMode, disableSelectionMode, isSelectionModeEnabled };
export { setPivotOnBarycenter };
export { resetSelectedToothToInitialPosition, restoreSelectedToothToNextPosition, undoSelectedToothLastMovement };
export { collectToothDataForSave, collectMalocAndSetupVersionsData };
export { clearSessionMovementHistory, addToSessionMovementHistory };
export { refreshModifications };

export const resetAllTeethToInitialPosition = () => _resetAllTeethToInitialPosition(globalTeethObjects);

export const hasAnyToothBeenModified = () => _hasAnyToothBeenModified(globalTeethObjects);

export const saveModifications = async () => _saveModifications();

export const removeModification = async () => _removeModification();

export const applyModification = async (id, applyOnComparative = false) => {
    await _applyModification(id, applyOnComparative, getContext());
};
